import moment from 'moment'

import { StatisticValue } from '@/generated/graphql'

export const compensateMonthData = (year: number, array: StatisticValue[]) => {
  let month = 11
  const currentMonth = moment().month()

  // 不显示未来日期
  if (year === moment().year()) {
    month = currentMonth
  }

  return Array.from({ length: month + 1 }, (_x, index) => {
    const yearMonth = moment([year, index, 1]).format('YYYY-MM')
    const item = array.find((item) => item.yearMonth === yearMonth)
    return item || { yearMonth, value: 0 }
  })
}
